import { KnownComponentsNames } from "@core/components-names";

export const allowedApps: KnownComponentsNames[] = [
    KnownComponentsNames.AohsComponent,
    KnownComponentsNames.ImageHub,
]